import { createAsyncThunk } from '@reduxjs/toolkit'
import toCamel from 'lodash-humps'
// imported directly rather than from '../common': that barrel pulls in UI modules that touch `window`,
// which would keep the slice from loading under Jest
import { errorHandler, throwTextErrorForErrorResponse, type ErrorPayload } from '../common/error/errorAPI'

type ThunkConfig = {
  state: { common: { baseUri: string } }
  rejectValue: ErrorPayload
}

export type MonthRangeParams = {
  from?: string
  to?: string
}

export const fetchMonthlyEngineStats = createAsyncThunk<unknown, MonthRangeParams, ThunkConfig>(
  'admin/fetchMonthlyEngineStats',
  async ({ from, to }, { getState, rejectWithValue, signal }) => {
    const { baseUri } = getState().common
    const query = new URLSearchParams()
    if (from) query.set('from', from)
    if (to) query.set('to', to)
    const queryString = query.toString()

    return fetch(`${baseUri}admin/monthly_engine_stats${queryString ? `?${queryString}` : ''}`, {
      headers: {
        Accept: 'application/json'
      },
      signal
    })
      .then(throwTextErrorForErrorResponse)
      .then((response) => response.json())
      .then(toCamel)
      .catch(errorHandler(rejectWithValue))
  }
)
